export const locale = {
    lang: 'pl',
    data: {
        'LOGIN TO YOUR ACCOUNT': 'Zaloguj się do aplikacji',
        'Email is required': 'Adres e-mail jest wymagany',
        'Password': 'Hasło',
        'Password is required': 'Hasło jest wymagane',
        'LOGIN': 'ZALOGUJ',
        'If you want to login then you should be at work!': 'Aby się zalogować należy być w pracy!',
    }
};
